__webpack_require__.p = "https://order-details.core-artifacts.com/static/";